export const burger=[
    {
      "quantity":1,
      "id":30,
    "name":"2 Chicken Krisper Burgers",
    "detail":"2 delicious chicken value burgers - at a deal price",
    "price":228.57,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-PR00001025.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":31,
    "name":"2 Veg Krisper Burgers",
    "detail":"2 delicious veg value burgers - at a deal price",
    "price":158.10,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-PR00001022.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":32,
    "name":"Chicken & Krispers Combo",
    "detail":"Deal combo of 2 chicken value burgers, 2 pc Hot & Crispy, 2 dips & a chilled Pepsi PET",
    "price":519.05,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-PR00001027.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":33,
    "name":"Tandoori Zinger Burger",
    "detail":"Chicken zinger with a delicious tandoori sauce",
    "price":199.05,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-K540.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":34,
    "name":"Mixed Zinger Doubles",
    "detail":"Best-seller combo of classic chicken zinger & tandoori zinger",
    "price":348.57,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-PR00000956.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":35,
    "name":"Classic Zinger Burger",
    "detail":"Signature burger made with a crunchy chicken fillet, veggies & a delicious mayo sauce",
    "price":189.52,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-K439.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":36,
    "name":"Buddy Meal",
    "detail":"Share 2 Classic Chicken Zingers & a Medium Popcorn in this delightful combo for 2",
    "price":499.05,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-PR00000730.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":37,
    "name":"Veg Zinger Burger",
    "detail":"Signature veg burger with crispy patties, veggies & a tangy sauce",
    "price":179.05,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-K146.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":38,
    "name":"2 Veg Krispers Meal",
    "detail":"2 veg value burgers, crispy medium fries & 2 delicious dips at a deal price!",
    "price":268.57,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-PR00001023.jpg?ver=20.85"
    }
    ];